import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=567159a4&scoped=true&"
import script from "./ServiceInformation.js?vue&type=script&lang=js&"
export * from "./ServiceInformation.js?vue&type=script&lang=js&"
import style0 from "./ServiceInformation.vue?vue&type=style&index=0&id=567159a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567159a4",
  null
  
)

export default component.exports